import React from 'react';
// import ProfileService from '../../services/profile.service';
// import PropTypes from 'prop-types';
import './style.css';

const Footer = ({ t, showFooter }) => (
  <React.Fragment>
    {
      !!showFooter &&
      <div className="footer boxs">
        <div className="container">
          <span className="fontmulisemi">
            {t('Portal created with')}
            <a href="https://www.yarea.io/">
              <img src="/img/logo.png" alt="Yarea" className="img-responsive footer-copyright-logo" />
            </a>
          </span>
        </div>
      </div>
    }
  </React.Fragment>
);

Footer.propTypes = {
};

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/footer/Footer.js